/* eslint-disable */
export default function initCookieConsent() {
  if (typeof CookieConsent === 'undefined') {
    console.error('CookieConsent library not loaded');
    return;
  }

  // Allow page interaction on privacy policy page so users can read it before consenting
  const isPrivacyPolicyPage = window.location.pathname.includes('conditions-dutilisation');

  CookieConsent.run({
    disablePageInteraction: !isPrivacyPolicyPage,
    guiOptions: {
      consentModal: {
        layout: 'box',
        position: 'bottom right',
        equalWeightButtons: true,
        flipButtons: false,
      },
      preferencesModal: {
        layout: 'box',
        position: 'right',
        equalWeightButtons: true,
        flipButtons: false,
      },
    },
    categories: {
      necessary: {
        readOnly: true,
      },
      analytics: {},
      functionality: {},
    },
    language: {
      default: 'fr',
      autoDetect: 'document',
      translations: {
        fr: {
          consentModal: {
            title: 'Ce site utilise des témoins (cookies)',
            description:
              "Des témoins de suivi sont utilisés pour optimiser votre navigation sur SAgE pesticides, analyser l'achalandage et personnaliser le contenu. Certaines données recueillies peuvent constituer des renseignements personnels. Votre consentement peut être donné ou retiré en tout temps.",
            acceptAllBtn: 'Tout accepter',
            acceptNecessaryBtn: 'Tout rejeter',
            showPreferencesBtn: 'Gérer les préférences',
            footer:
              '<a href="/conditions-dutilisation/">Termes et conditions</a>',
          },
          preferencesModal: {
            title: 'Gérer les préférences',
            acceptAllBtn: 'Tout accepter',
            acceptNecessaryBtn: 'Tout rejeter',
            savePreferencesBtn: 'Sauvegarder les préférences',
            closeIconLabel: 'Fermer la modale',
            serviceCounterLabel: 'Services',
            sections: [
              {
                title: 'Utilisation des témoins (cookies)',
                description:
                  "Des témoins de suivi sont utilisés pour optimiser votre navigation sur SAgE pesticides, analyser l'achalandage et personnaliser le contenu.",
              },
              {
                title:
                  'Témoins strictement nécessaires <span class="pm__badge">Toujours Actif</span>',
                description:
                  'Ces témoins sont essentiels au bon fonctionnement du site Web (maintien de la session, sécurité, enregistrement des préférences de consentement). Ils ne recueillent pas de renseignements personnels pour le profilage et ne peuvent pas être désactivés.',
                linkedCategory: 'necessary',
              },
              {
                title: "Témoins d'analyse",
                description:
                  "Ces témoins nous permettent de mesurer le nombre de visites et les sources de trafic (Google Analytics). Ils nous aident à comprendre comment les visiteurs interagissent avec le site. Les données recueillies incluent des renseignements sur votre navigation, comme l'adresse IP anonymisée et les pages visitées.",
                linkedCategory: 'analytics',
              },
              {
                title: 'Témoins de performance et de fonctionnalité',
                description:
                  "Ces témoins sont utilisés pour améliorer l'expérience utilisateur et les fonctionnalités du site (mémoriser la langue sélectionnée, préférences d'affichage).",
                linkedCategory: 'functionality',
              },
            ],
          },
        },
        en: {
          consentModal: {
            title: 'This site uses cookies',
            description:
              'Tracking cookies are used to optimize your browsing experience on SAgE pesticides, analyze traffic and personalize content. Some collected data may constitute personal information. Your consent can be given or withdrawn at any time.',
            acceptAllBtn: 'Accept all',
            acceptNecessaryBtn: 'Reject all',
            showPreferencesBtn: 'Manage preferences',
            footer:
              '<a href="/conditions-dutilisation/">Terms and conditions</a>',
          },
          preferencesModal: {
            title: 'Manage preferences',
            acceptAllBtn: 'Accept all',
            acceptNecessaryBtn: 'Reject all',
            savePreferencesBtn: 'Save preferences',
            closeIconLabel: 'Close modal',
            serviceCounterLabel: 'Services',
            sections: [
              {
                title: 'Use of cookies',
                description:
                  'Tracking cookies are used to optimize your browsing experience on SAgE pesticides, analyze traffic and personalize content.',
              },
              {
                title:
                  'Strictly necessary cookies <span class="pm__badge">Always Active</span>',
                description:
                  'These cookies are essential for the proper functioning of the website (session maintenance, security, consent preference recording). They do not collect personal information for profiling and cannot be disabled.',
                linkedCategory: 'necessary',
              },
              {
                title: 'Analytics cookies',
                description:
                  'These cookies allow us to measure the number of visits and traffic sources (Google Analytics). They help us understand how visitors interact with the site. The data collected includes information about your browsing, such as anonymized IP address and pages visited.',
                linkedCategory: 'analytics',
              },
              {
                title: 'Performance and functionality cookies',
                description:
                  'These cookies are used to improve user experience and site functionality (remembering selected language, display preferences).',
                linkedCategory: 'functionality',
              },
            ],
          },
        },
      },
    },
  });
}
